"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = _interopRequireDefault(require("underscore"));

var _StateContainer = require("../../utils/StateContainer");

var _DeprecationUtils = require("../../../util/DeprecationUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @enum {string}
 * @alias Toggle.Status
 */
var Status = {
  LOCKED: "locked"
};
/**
* @callback Toggle~onToggle
*/

/**
* @class Toggle
* @desc Toggles between two states on click. Is either "off" or "on".
*
* @param {string} [data-id=toggle]
*     To define the base "data-id" value for top-level HTML container.
* @param {string} [className]
*     CSS classes to be set on the top-level HTML container.
*
* @param {boolean} [disabled=false]
*     If disabled then the toggle will be styled with a "disabled" class and will not be clickable.
* @param {boolean} [stateless]
*     WARNING. Default value for "stateless" will be set to true from next version.
*     To enable the component to be externally managed. True will relinquish control to the component's owner.
*     False or not specified will cause the component to manage state internally.
* @param {boolean} [toggled=false]
*     Toggle state; either true for "on" or false for "off".
*     When not provided, the component will manage this value.
* @param {string} [name]
*     Name attribute for the input.
*
* @param {Toggle.Status} [status]
*     The status determines aspects of the visual presentation of the toggle. Ex: if status=locked then the off state
*     of the toggle has a yellow bg color instead of the default gray
* @param {Toggle~onToggle} [onToggle]
*     Callback to be triggered when toggled state changes.
*
*
* @example
*     <Toggle className="small" onToggle={this._handleToggle} toggled={true} />
*/

var Stateless = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Stateless, _Component);

  var _super = _createSuper(Stateless);

  function Stateless() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, Stateless);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleToggle", function () {
      if (_this.props.disabled) {
        return;
      }

      _this.props.onToggle();
    });
    return _this;
  }

  (0, _createClass2.default)(Stateless, [{
    key: "render",
    value: function render() {
      var status = this.props.status ? Status[this.props.status.toUpperCase()] : null,
          className = (0, _classnames.default)("input-toggle", this.props.className, status, {
        selected: this.props.toggled,
        disabled: this.props.disabled
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-id": this.props["data-id"],
        className: className,
        onClick: this._handleToggle
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "toggle"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "hidden",
        name: this.props.name
      })));
    }
  }]);
  return Stateless;
}(_react.Component);

(0, _defineProperty2.default)(Stateless, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  toggled: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  name: _propTypes.default.string
});
(0, _defineProperty2.default)(Stateless, "defaultProps", {
  "data-id": "toggle",
  className: "",
  disabled: false,
  onToggle: _underscore.default.noop
});
var Toggle = (0, _StateContainer.inStateContainer)([{
  name: "toggled",
  initial: false,
  callbacks: [{
    name: "onToggle",
    transform: _StateContainer.toggleTransform
  }]
}])(Stateless);
Toggle.displayName = "Toggle";
Toggle.propTypes = {
  stateless: _DeprecationUtils.deprecatedStatelessProp
};
Toggle.Status = Status;
module.exports = Toggle;